var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverallFinancialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.3008C14.25 13.5434 13.2426 14.5508 12 14.5508C10.7574 14.5508 9.75 13.5434 9.75 12.3008C9.75 11.0582 10.7574 10.0508 12 10.0508C13.2426 10.0508 14.25 11.0582 14.25 12.3008Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8501 11.8398V11.8488",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1499 12.7383V12.7473",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 6C17.8315 6 19.3713 6.34578 20.2196 6.60869C20.708 6.76006 21 7.223 21 7.73435V16.5141C21 17.5177 19.8947 18.2728 18.9086 18.0866C18.0625 17.9268 16.9596 17.7985 15.6 17.7985C11.3242 17.7985 10.2986 19.4236 4.03032 18.0413C3.42538 17.9079 3 17.3639 3 16.7444V7.72904C3 6.85077 3.82871 6.21029 4.69018 6.38124C10.377 7.50971 11.4788 6 15.6 6Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallFinancialsIcon);
export default __webpack_public_path__ + "static/media/overall_financials_icon.921251a7b98680b0ca4fa6dc01488697.svg";
export { ForwardRef as ReactComponent };